import gql from 'graphql-tag'

export const fetchCartValuesQuery = gql(`
query ($cart_id: String!) {
  cart(
      cart_id: $cart_id
  )  {
    free_beer_active
    delivery_date
    delivery_method
    id
    total_quantity
    multi_deposit
    ship_to_id
    grand_total_your_price_details
    grand_total_multi_deposit
    bundle_your_price_sum_grand_total
    quantity_totals
    outlet_details {
      payer_name
      outlet_name
      street
      city
      country
      province
      postalcode
      sap_id
    }
    cart_prices {
      grand_total_price
      grand_total_price_with_vat
      total_discount_basic
      total_discount_cash
      total_discount_packaging
      total_discount_promotional
      free_beer_total
      summary
    }  
    items {      
      id
      uid
      is_free_beer
      prices {
        price_details
        multi_deposit_details
        total_item_discount {
          value
        }
        price {
          value
        }
        favourites
        row_total {
          value
        }
        discounts {
          label
          amount {
            value
          }
        }
      }
      product {
        hectolitres_fe
        additional_weight
        special_offer_details{
          max_purchasable_qty
          valid_from
          valid_to
          deliverable_from
          deliverable_to
          deliverable_flag
          layer_error_flag
        }
        low_stock_pl {
          is_lowstock
          out_of_stock
          rotation_day
          quantity
        }
        id
        name
        high_margin
        product_sale
        product_new
        product_recommended
        product_lowstock
        promotional
        free_beer
        catalog_product_name
        sku
        disable_for_layer_ordering_fe
        disable_for_pallet_ordering_fe
        url_key
        material_type
        number_of_items_in_box
        number_of_items_on_pallet
        swatch_image
        number_of_products_on_layer
        number_of_layers_per_pallet
        isavailable_truck_package_ordering
        image {
          url
        }
        ... on BundleProduct {
          bundle_price_details
        }
        __typename
      }
      ... on BundleCartItem {
          bundle_options {
            uid
            label
            type
            values {
              id
              label
              price
              quantity
            }
          }
        }
      quantity
      quantity_total
      number_of_packages
      number_of_layer_freebeer
      number_of_layer
      number_of_layer_total
      number_of_pallet
      pack_format
      
    }
    progress_bar_data {
    color
    sSpecialOfferDeliverableFlag
    sSpecialOfferLayerFlag
    sHighMarginAvgValue
    sHighMarginFlag
    cashDiscount  {
      cashamount
      isactive
      canshow
    }
    brand_progressbar {
        brand
        sub_brand
        hectolitres
        cases
      }
      isFullTruck
      isHalfTruck
      isSmallOrder
      isCheckoutEnable
      boolIncludeWeightCalculation
      iMinimumOrderPallet
      iMaximumOrderPallet
      iMinimumOrderWeight
      iMaximumOrderWeight
      sOutletDeliveryMethod
      iTotalCartWeight
      iTotalCartPalletQty
      iTotalCartVoulume
      iTotalFreeItems
      status
      can_show_layer_notice
    }
  }
}
`)
